import {OrdersState} from './orders.state';
import {createReducer, on} from '@ngrx/store';
import {OrdersActions} from './orders.index';

export const ordersFeatureKey = 'orders';

const initialState: OrdersState = {
  order: null,
  orders: {
    isLoading: false,
    data: []
  },
  channels: [],
  selectedTabIndex: 0,
  overview: {
    bmPositions: [],
    tlPositions: [],
    tpPositions: [],
    order: undefined,
    orderStatusIcons: undefined
  },
  overviewIsLoading: false
};

const reducer = createReducer(
  initialState,
  on(
    OrdersActions.LOAD_ORDER,
    state => state
  ),
  on(
    OrdersActions.LOAD_ORDER_SUCCESS,
    (state, action) => ({
      ...state,
      order: action.order
    })
  ),
  on(
    OrdersActions.LOAD_ORDER_ERROR,
    state => state
  ),
  on(
    OrdersActions.LOAD_ORDERS,
    (state, action) => ({
      ...state,
      orders: {
        isLoading: true,
        data: []
      }
    })
  ),
  on(
    OrdersActions.LOAD_ORDERS_SUCCESS,
    (state, action) => ({
      ...state,
      orders: {
        isLoading: false,
        data: action.orders
      }
    })
  ),
  on(
    OrdersActions.LOAD_ORDERS_ERROR,
    (state, action) => ({
      ...state,
      orders: {
        isLoading: false,
        data: []
      }
    })
  ),
  on(
    OrdersActions.LOAD_CHANNELS,
    state => state
  ),
  on(
    OrdersActions.LOAD_CHANNELS_SUCCESS,
    (state, action) => ({
      ...state,
      channels: action.channels
    })
  ),
  on(
    OrdersActions.LOAD_CHANNELS_ERROR,
    state => state
  ),
  on(
    OrdersActions.SELECT_TAB_INDEX,
    (state, action) => ({
      ...state,
      selectedTabIndex: action.index
    })
  ),
  on(
    OrdersActions.LOAD_OVERVIEW, state => ({...state, overviewIsLoading: true})
  ),
  on(
    OrdersActions.LOAD_OVERVIEW_SUCCESS,
    (state, action) => ({
      ...state,
      overview: action.overview,
      overviewIsLoading: false
    })
  ),
  on(
    OrdersActions.LOAD_OVERVIEW_ERROR, state => ({...state, overviewIsLoading: false})
  )
);


export function ordersReducer(state: OrdersState, action) {
  return reducer(state, action);
}
